// Matomo
import VueMatomo from 'vue-matomo'
import type { App } from 'vue'
import type { Router } from 'vue-router'

const matomo = (app: App, router: Router) => {
  console.log('installing matomo plugin')
  if (import.meta.env.VITE_MATOMO_ENABLED === 'true') {
    console.log('Matomo is enabled')
    app.use(VueMatomo.default, {
      router,
      host: import.meta.env.VITE_MATOMO_HOST,
      siteId: import.meta.env.VITE_MATOMO_SITE_ID,
    })
  }
}

export default matomo
